module.exports = __webpack_public_path__ + "img/pigeon.be5030ca.webp";